export default function ModalImage({
  setModalOpen,
  setCurrentImage,
  images,
  currentImage,
}) {
  console.log("Current Image:", currentImage, images);
  return (
    <section className="fixed inset-0 z-50 flex items-center justify-center bg-black/80">
      <div className="mx-4 max-h-[90vh] w-full max-w-4xl overflow-y-auto rounded-lg bg-white p-6">
        <button
          onClick={() => setModalOpen(false)}
          className="cursor-pointer text-2xl text-black hover:text-[#3e3e3e] w-full inline-flex justify-end"
          aria-label="Close modal"
        >
          &times;
        </button>
        <div className="relative">
          <div className="w-[400px] h-[400px] mx-auto">
            <img
              src={currentImage.url}
              alt={`${currentImage + 1}`}
              className="w-full h-full object-contain"
            />
          </div>

          {images.length > 1 && (
            <>
              <div className="my-6 flex justify-center space-x-2">
                {images.map((image) => (
                  <button
                    key={image.name}
                    onClick={() => setCurrentImage(image)}
                    className={`h-3 w-3 cursor-pointer rounded-full ${
                      currentImage.name === image.name
                        ? "bg-black"
                        : "bg-gray-300"
                    }`}
                  />
                ))}
              </div>
              <button
                onClick={() => {
                  const currentIndex = images.findIndex(
                    (img) => img.name === currentImage.name,
                  );
                  const prevIndex =
                    (currentIndex - 1 + images.length) % images.length;
                  const prevImage = images[prevIndex];
                  setCurrentImage(prevImage);
                }}
                className="absolute top-1/2 left-2 -translate-y-1/2 cursor-pointer rounded-full bg-black/50 w-10 h-10 text-3xl text-white hover:bg-black/60"
              >
                ‹
              </button>
              <button
                onClick={() => {
                  const currentIndex = images.findIndex(
                    (img) => img.name === currentImage.name,
                  );
                  const nextIndex = (currentIndex + 1) % images.length;
                  const nextImage = images[nextIndex];
                  setCurrentImage(nextImage);
                }}
                className="absolute top-1/2 right-2 -translate-y-1/2 cursor-pointer rounded-full bg-black/50 w-10 h-10 text-3xl text-white hover:bg-black/60"
              >
                ›
              </button>
            </>
          )}
        </div>
      </div>
    </section>
  );
}
